import React from 'react';

import PlusMultIcon from '../icons/PlusMultIcon';

function InputErrors({ errors }) {
  // Protect against mystery responses
  if (!Array.isArray(errors)) return null;

  return (
    <div className="input-errors">
      <PlusMultIcon rotated errorColor />
      <div>
        {errors.map(error => (
          <p key={error}>
            {error}
          </p>
        ))}
      </div>
    </div>
  );
}

export default InputErrors;



// WEBPACK FOOTER //
// ./src/components/common/InputErrors.js